import { Injectable, NgZone } from "@angular/core";

import { Platform } from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";
import { ProductServiceProvider } from "./../../pages/products/product.service";
import { HelperServiceProvider } from "./helper.service";

@Injectable()
export class Shutdown {
	constructor(
		public zone: NgZone,
		public platform: Platform,
		public addOrderService: AddOrderServiceProvider,
		public productServiceProvider: ProductServiceProvider,
		public helperService: HelperServiceProvider
	) {}

	clear() {
		this.addOrderService.clear();
		this.productServiceProvider.clear();
		this.helperService.clear();
	}
}
	



// WEBPACK FOOTER //
// ./src/common/services/shutdown.ts